import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Editor, schema, Toolbar } from 'ngx-editor';
import { Parent } from 'src/app/models/parents-section.model';
import { ParentsService } from 'src/app/services/parents-section.service';
import { FileUpload } from 'src/app/models/file-upload.model';

@Component({
  selector: 'app-dla-rodzicow-modal',
  templateUrl: './dla-rodzicow-modal.component.html',
  styleUrls: ['./dla-rodzicow-modal.component.sass']
})
export class DlaRodzicowModalComponent implements OnInit, OnDestroy {

  public editor_text: Editor;
  public html_text: string = '';
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  public operation?: string;
  public parentToEdit?: Parent;
  selectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  percentage = 0;
  public form: FormGroup = new FormGroup(
    {
      text: new FormControl('', Validators.required),
      priority: new FormControl(false),
    }
  );

  constructor(public modalRef: MdbModalRef<DlaRodzicowModalComponent>,
     public fb: FormBuilder, 
     private parentService: ParentsService) { 
          this.editor_text = new Editor();
 }

  ngOnInit(): void {
    if (this.parentToEdit) {
      this.form = new FormGroup(
        {
          text: new FormControl(this.parentToEdit.text || '', Validators.required),
          priority: new FormControl(this.parentToEdit.important || false),
        }
      )
      this.html_text = this.parentToEdit.text
    }
  }

  get f() {
    return this.form.controls;
  }

  close(): void {
    this.modalRef.close(this.form)
  }

  submit() {
    if (this.form.valid) {
      if (this.operation) {
        if (this.parentToEdit) {
          const newParent: any = {
            text: this.f.text.value,
            important: this.f.priority.value,
            date: this.parentToEdit.date
          };
          if (this.currentFileUpload && this.currentFileUpload.name) {
            newParent.fileName = this.currentFileUpload.name;
          } else if (this.parentToEdit.fileName) {
            newParent.fileName = this.parentToEdit.fileName;
          }
          this.parentService.updateParent(this.parentToEdit, newParent);
          this.modalRef.close(this.form);
        }
      }
      else {
        const newParent: any = {
          text: this.f.text.value,
          important: this.f.priority.value,
          date: new Date().toISOString()
        };
        if (this.currentFileUpload && this.currentFileUpload.name) {
          newParent.fileName = this.currentFileUpload.name;
        }
        console.log('Submitting new parent:', newParent);
        this.parentService.addParent(newParent);
        this.modalRef.close(this.form);
      }
    }
  }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }

  upload(): void {
    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);
      this.selectedFiles = undefined;

      if (file) {
        this.currentFileUpload = new FileUpload(file);
        this.parentService.pushFileToStorage(this.currentFileUpload).subscribe(
          percentage => {
            this.percentage = Math.round(percentage ? percentage : 0);
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }

  operationText(): string {
    if (this.operation) {
      return "Zapisz";
    }
    return "Dodaj";
  }

  ngOnDestroy(): void {
    if(this.editor_text)
    this.editor_text.destroy()
  }

  

}
